import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, Box, CircularProgress, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useFetchRecentHealthcareServices } from 'hooks';
import { CircleIcon, TimeIcon } from 'components/elements/Icons';
import BookAppointmentService from './BookAppointmentService';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function BookAppointmentServiceTypes({ onSelectServiceType, isServiceRequest, onClickBack }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const { data: bookingServices, isLoading } = useFetchRecentHealthcareServices(isServiceRequest);

  return (
    <>
      {!isServiceRequest && (
        <div className={classes.headInfo}>
          <Typography variant="body1" component="p">
            {t('set_up_a_followup_with_your_provider_based_on_your_previous_services')}
          </Typography>
          <Typography variant="body1" component="p">
            {t('you_will_only_see_services_from_the_past_12_months')}
          </Typography>
        </div>
      )}

      {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      )}
      {!isLoading && bookingServices.length
        ? bookingServices.map(({ name, description, duration, id }) => (
            <BookAppointmentService key={id} onClick={() => onSelectServiceType({ id, name })}>
              <div className={classes.bookAppointmentServiceInfo}>
                <div className={classes.serviceInfoItemWrap}>
                  <CircleIcon classes={classes.circleIcon} />
                  <Typography sx={{ fontWeight: 'bold' }} variant="h6" component="h6" noWrap>
                    {name}
                  </Typography>
                </div>
                {description && (
                  <div className={classes.serviceInfoItemWrap}>
                    <Typography className={classes.serviceDescription} variant="body1" component="span">
                      {description}
                    </Typography>
                  </div>
                )}
                {duration && (
                  <div className={classes.serviceInfoItemWrap}>
                    <TimeIcon classes={classes.serviceDescriptionIcon} />
                    <Typography className={classes.serviceDescription} variant="body1" component="span" noWrap>
                      {duration} {t('minutes')}
                    </Typography>
                  </div>
                )}
              </div>
            </BookAppointmentService>
          ))
        : null}
      {!isLoading && bookingServices.length === 0 && (
        <Typography className={classes.noServiceTitle} variant="body1" component="div">
          {t('no_services_available_please_contact_clinic_for_more_details')}
        </Typography>
      )}
      {!isLoading && isServiceRequest && (
        <div className={classes.controlButton}>
          <Button onClick={onClickBack} variant="outlined" color="primary" size="large" className={classes.bookAppointmentServiceBackButton}>
            {t('back')}
          </Button>
        </div>
      )}
    </>
  );
}

BookAppointmentServiceTypes.propTypes = {
  onSelectServiceType: PropTypes.func.isRequired,
  isServiceRequest: PropTypes.bool,
  onClickBack: PropTypes.func.isRequired,
};

BookAppointmentServiceTypes.defaultProps = {
  isServiceRequest: null,
};

export default BookAppointmentServiceTypes;
